import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faFile,
  faFileInvoiceDollar,
  faPrint,
  faShoppingCart,
  faUndoAlt,
  faSignOutAlt,
  faCircleXmark,
  faRefresh,
  faTrashArrowUp,
  faClockRotateLeft,
  faCartArrowDown,
  faCartShopping,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import Reimpressao from "./Reimpressao";
import { Button, Modal, Select, message } from "antd";
import Cancelamento from "./Cancelamento";
import TelaVendas from "./TelaVendas";
import Orcamentos from "./Orcamentos/Orcamentos";
import Devolucao from "./Devolucao";
import Log from "./Log/Log";
import { useConfigQuery } from "../../../queries/useConfig";
import axios from "axios";
import { api } from "../../../config/api";
import ControleCaixaTela from "./ControleCaixaTela";

const Vendas = () => {
  const { data: config, error } = useConfigQuery();
  const [key, setKey] = React.useState(0);

  const [isModalVisible, setIsModalVisible] = useState(false);

  // ✅ em vez de guardar JSX "congelado", guarda só QUAL tela abrir
  const [modalKey, setModalKey] = useState(null);

  const [pagamentoConcluido, setPagamentoConcluido] = useState(false);
  const [pagamentos, setPagamentos] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [consumidorIdentificado, setConsumidorIdentificado] = useState(false);
  const [consumidor, setConsumidor] = useState(null);

  const [msgSairTela, setMsgSairTela] = useState("");
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [loading, setLoading] = useState(false);
  const [pagItem, setPagItem] = useState([]);

  // Controle de caixa
  const [validandoCaixa, setValidandoCaixa] = useState(false);
  const [sessaoCaixa, setSessaoCaixa] = useState(null);
  const [caixa, setCaixa] = useState(null);
  const [caixasDisponiveis, setCaixasDisponiveis] = useState([]);
  const [caixaSelecionado, setCaixaSelecionado] = useState(undefined);
  const [isModalCaixaVisible, setIsModalCaixaVisible] = useState(false);
  const [acaoPendenteCaixa, setAcaoPendenteCaixa] = useState(null);

  // Abertura de uma sessão recém-criada
  const [isAberturaCaixaVisible, setIsAberturaCaixaVisible] = useState(false);
  const [acaoAposAbertura, setAcaoAposAbertura] = useState(null);

  const CAIXA_URL = `${api.techspdv}/api/caixas`;
  const SESSAO_CAIXA_URL = `${api.techspdv}/api/sessoes-caixa`;


  const resetStates = () => {
    setProdutos([]);
    setKey((prevKey) => prevKey + 1);
  };

  const bloquearAcesso = (palavra) => {
    if (!palavra) return false;

    const bloqueios = config?.bloqueiosDoUsuario;
    if (!bloqueios) return false;

    return bloqueios.toLowerCase().includes(String(palavra).toLowerCase());
  };

  // ✅ agora abre por "key" (vendas, orcamentos, etc.)
  const handleOpenModal = (key) => {
    setModalKey(key);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setModalKey(null);
  };

  const getAuthOptions = (params = {}) => ({
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
    params,
  });

  const abrirTela = (key, mensagemSaida) => {
    handleOpenModal(key);
    setMsgSairTela(mensagemSaida);
  };

  const criarSessaoCaixa = async (caixa, key, mensagemSaida) => {
    if (!caixa?.id) {
      message.error("Caixa inválido.");
      return;
    }

    try {
      setValidandoCaixa(true);

      const { data } = await axios.post(
        SESSAO_CAIXA_URL,
        {
          ativo: true,
          abertura: new Date().toISOString(),
          fechamento: null,
          saldoInicial: 0,
          saldoFinal: null,
          idCaixa: caixa.id,
        },
        getAuthOptions({
          idUsuario: idUser,
          idLoja: config?.idLoja,
        })
      );

      console.log(caixa);

      const novaSessaoCaixa = {
        ...data,
        caixaDescricao: caixa.descricao,
      };

      setSessaoCaixa(novaSessaoCaixa);

      setIsModalCaixaVisible(false);
      setCaixasDisponiveis([]);
      setCaixaSelecionado(undefined);
      setAcaoPendenteCaixa(null);

      /*
       * A sessão acabou de ser criada.
       * Antes de entrar em Vendas/Pedidos, solicita a
       * movimentação de ABERTURA do caixa.
       */
      setAcaoAposAbertura({
        key,
        mensagemSaida,
      });

      setIsAberturaCaixaVisible(true);
    } catch (error) {
      console.error("Erro ao criar sessão de caixa:", error);

      message.error(
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        "Não foi possível abrir a sessão de caixa."
      );
    } finally {
      setValidandoCaixa(false);
    }
  };

  const confirmarAberturaCaixa = (payload) => {
    console.log("Abertura do caixa:", payload);

    setIsAberturaCaixaVisible(false);

    if (acaoAposAbertura) {
      abrirTela(
        acaoAposAbertura.key,
        acaoAposAbertura.mensagemSaida
      );
    }

    setAcaoAposAbertura(null);
  };

  const cancelarAberturaCaixa = () => {
    /*
     * A sessão já foi criada no backend.
     * Por enquanto apenas não entra na tela de venda/pedido.
     *
     * Se quiser, depois podemos alterar para fechar/cancelar
     * automaticamente a sessão quando o usuário cancelar aqui.
     */
    setIsAberturaCaixaVisible(false);
    setAcaoAposAbertura(null);
  };


  const confirmarCaixaSelecionado = async () => {
    const caixa = caixasDisponiveis.find(
      (item) => String(item.id) === String(caixaSelecionado)
    );

    if (!caixa) {
      message.warning("Selecione o caixa que deseja utilizar.");
      return;
    }

    if (!acaoPendenteCaixa) {
      message.error("Não foi possível identificar a tela que seria aberta.");
      return;
    }

    await criarSessaoCaixa(
      caixa,
      acaoPendenteCaixa.key,
      acaoPendenteCaixa.mensagemSaida
    );
  };

  const validarAcessoComCaixa = async (key, mensagemSaida) => {
    // Neste primeiro momento, somente Vendas e Pedidos usam controle de caixa.
    if (key !== "vendas" && key !== "pedidos") {
      abrirTela(key, mensagemSaida);
      return;
    }

    if (!config?.idLoja) {
      message.error("Não foi possível identificar a loja.");
      return;
    }

    if (!idUser) {
      message.error("Não foi possível identificar o usuário.");
      return;
    }

    try {
      setValidandoCaixa(true);

      // 1) Primeiro tenta reutilizar uma sessão ativa do usuário nesta loja.
      try {
        const { data: sessaoAtiva } = await axios.get(
          `${SESSAO_CAIXA_URL}/ativa`,
          getAuthOptions({
            idUsuario: idUser,
            idLoja: config.idLoja,
          })
        );

        if (sessaoAtiva?.id && sessaoAtiva?.ativo !== false) {
          setSessaoCaixa(sessaoAtiva);
          abrirTela(key, mensagemSaida);
          return;
        }
      } catch (errorSessao) {
        /*
         * 404 significa apenas que o usuário ainda não possui sessão ativa.
         * Qualquer outro erro continua sendo tratado normalmente.
         */
        if (errorSessao?.response?.status !== 404) {
          throw errorSessao;
        }
      }

      // 2) Sem sessão: procura caixas ativos vinculados ao usuário nesta loja.
      const { data: caixasUsuarioResponse } = await axios.get(
        `${CAIXA_URL}/usuario/${idUser}`,
        getAuthOptions({
          idLoja: config.idLoja,
        })
      );

      const caixasUsuario = Array.isArray(caixasUsuarioResponse)
        ? caixasUsuarioResponse.filter(
          (caixa) => caixa?.ativo === true || caixa?.ativo === 1
        )
        : [];

      // Um único caixa ativo: cria a sessão automaticamente.
      if (caixasUsuario.length === 1) {
        await criarSessaoCaixa(
          caixasUsuario[0],
          key,
          mensagemSaida
        );

        setCaixa(caixasUsuario[0]);
        return;
      }

      // Mais de um caixa ativo: usuário escolhe qual deseja abrir.
      if (caixasUsuario.length > 1) {
        setCaixasDisponiveis(caixasUsuario);
        setCaixaSelecionado(undefined);
        setAcaoPendenteCaixa({
          key,
          mensagemSaida,
        });
        setIsModalCaixaVisible(true);
        return;
      }

      /*
       * 3) O usuário não possui caixa ativo.
       * Verifica se a loja possui qualquer caixa ativo.
       *
       * - Nenhum caixa ativo na loja => loja não usa controle de caixa.
       * - Existe caixa ativo na loja => controle habilitado, mas este usuário
       *   não possui caixa liberado.
       */
      const { data: caixasLojaResponse } = await axios.get(
        `${CAIXA_URL}/ativos`,
        getAuthOptions({
          idLoja: config.idLoja,
        })
      );

      const caixasAtivosLoja = Array.isArray(caixasLojaResponse)
        ? caixasLojaResponse.filter(
          (caixa) => caixa?.ativo === true || caixa?.ativo === 1
        )
        : [];

      if (caixasAtivosLoja.length === 0) {
        setSessaoCaixa(null);
        abrirTela(key, mensagemSaida);
        return;
      }

      message.warning(
        "Você não possui um caixa ativo vinculado ao seu usuário. Procure um responsável."
      );
    } catch (error) {
      console.error("Erro ao validar controle de caixa:", error);

      message.error(
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        "Não foi possível validar o acesso ao caixa."
      );
    } finally {
      setValidandoCaixa(false);
    }
  };

  const recuperarVenda = async () => {
    try {
      setLoading(true);
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      const { data } = await axios.get(
        `${api.techspdv}/v1/venda-abandonada/${config?.idLoja}/${modalKey}`,
        options
      );

      const itens = Array.isArray(data?.produtos) ? data.produtos : [];
      setProdutos(itens.map((p) => ({ ...p })));
      setPagamentoConcluido(data?.pagamentoConcluido);
      setPagamentos(data?.pagamentos);
      setConsumidor(data?.consumidor);
      setConsumidorIdentificado(data?.consumidorIdentificado);
      setPagItem(data?.pagItem);



      setLoading(false);
    } catch (error) {
      console.log("Erro recuperarVenda:", error);
      setProdutos([]);
      setLoading(false);
    }
  };

  const handleExitClick = async () => {
    const confirmExit = window.confirm(`${msgSairTela}`);

    if (confirmExit) {
      if (modalKey === "vendas" || modalKey === "orcamentos" || modalKey === "pedidos") {
        try {
          const options = {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          };

          const abandono = await axios.put(
            `${api.techspdv}/v1/venda-abandonada/${config?.idLoja}/${modalKey}`,
            {
              produtos: produtos, pagamentoConcluido: pagamentoConcluido, pagamentos: pagamentos, consumidor: consumidor, consumidorIdentificado: consumidorIdentificado,
              pagItem: pagItem
            },
            options
          );

          console.log(abandono.data);
        } catch (error) {
          console.log("Erro ao salvar abandono:", error);
        }
      }

      resetStates();
      handleCloseModal();
    }
  };

  // ✅ evita "stale state" quando adiciona rápido
  const trataProdutos = (produto) => {
    setProdutos((prev) => [...prev, produto]);
  };

  return (
    <Container key={key}>
      <Button
        style={{ ...styles.buttonStyled, backgroundColor: "#841584" }}
        onClick={() =>
          validarAcessoComCaixa(
            "vendas",
            "Deseja abandonar a Venda?"
          )
        }
        disabled={bloquearAcesso("ve.vendas")}
        loading={validandoCaixa}
      >
        <FontAwesomeIcon icon={faShoppingCart} size="2x" />
        <ButtonText>Vendas</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("orcamentos");
          setMsgSairTela("Deseja abandonar o Orçamento?");
        }}
        disabled={bloquearAcesso("ve.orcamentos")}
        style={{ ...styles.buttonStyled, backgroundColor: "#FFA500" }}
      >
        <FontAwesomeIcon icon={faFileInvoiceDollar} size="2x" />
        <ButtonText>Orçamentos</ButtonText>
      </Button>


      <Button
        onClick={() =>
          validarAcessoComCaixa(
            "pedidos",
            "Deseja abandonar o Pedido?"
          )
        }
        disabled={bloquearAcesso("ve.pedidos")}
        loading={validandoCaixa}
        style={{ ...styles.buttonStyled, backgroundColor: "#FFA500" }}
      >
        <FontAwesomeIcon icon={faFileInvoiceDollar} size="2x" />
        <ButtonText>Pedidos</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("cancelamento");
          setMsgSairTela("Deseja sair da tela de Cancelamento?");
        }}
        disabled={bloquearAcesso("ve.cancelamento")}
        style={{ ...styles.buttonStyled, backgroundColor: "#FF6347" }}
      >
        <FontAwesomeIcon icon={faCircleXmark} size="2x" />
        <ButtonText>Cancelamento</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("devolucao");
          setMsgSairTela("Deseja sair da tela de Devolução?");
        }}
        disabled={bloquearAcesso("ve.devolucao")}
        style={{ ...styles.buttonStyled, backgroundColor: "#4682B4" }}
      >
        <FontAwesomeIcon icon={faUndoAlt} size="2x" />
        <ButtonText>Devolução</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("reimpressao");
          setMsgSairTela("Deseja sair da tela de Reimpressão?");
        }}
        disabled={bloquearAcesso("ve.reimpressao")}
        style={{ ...styles.buttonStyled, backgroundColor: "#32CD32" }}
      >
        <FontAwesomeIcon icon={faPrint} size="2x" />
        <ButtonText>Reimpressão</ButtonText>
      </Button>

      <Button
        onClick={() => {
          handleOpenModal("log");
          setMsgSairTela("Deseja sair da tela de Logs?");
        }}
        disabled={bloquearAcesso("ve.log")}
        style={{
          ...styles.buttonStyled,
          backgroundColor: "#000",
          opacity: "0.5",
        }}
      >
        <FontAwesomeIcon icon={faFile} size="2x" />
        <ButtonText>Log</ButtonText>
      </Button>

      <Modal
        visible={isAberturaCaixaVisible}
        footer={null}
        closable={false}
        maskClosable={false}
        width="100%"
        style={{ top: 0 }}
        centered
        className="full-screen-modal"
      >
        {isAberturaCaixaVisible && sessaoCaixa && (
          <ControleCaixaTela
            tipoMovimentacao="ENTRADA"
            operacao="ABERTURA"
            sessaoCaixa={sessaoCaixa}
            visible={isAberturaCaixaVisible}
            onClose={cancelarAberturaCaixa}
            onConfirm={confirmarAberturaCaixa}
          />
        )}
      </Modal>

      <Modal
        title="Selecione o Caixa"
        visible={isModalCaixaVisible}
        onCancel={() => {
          if (validandoCaixa) return;

          setIsModalCaixaVisible(false);
          setCaixasDisponiveis([]);
          setCaixaSelecionado(undefined);
          setAcaoPendenteCaixa(null);
        }}
        onOk={confirmarCaixaSelecionado}
        okText="Continuar"
        cancelText="Cancelar"
        confirmLoading={validandoCaixa}
        okButtonProps={{
          disabled: !caixaSelecionado,
          style: {
            backgroundColor: "#000",
            borderColor: "#000",
            color: "#fff",
          },
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#ff4d4f",
            borderColor: "#ff4d4f",
            color: "#fff",
          },
        }}
      >
        <div style={{ marginBottom: 8, fontWeight: "bold" }}>
          Você possui mais de um caixa ativo.
        </div>

        <div style={{ marginBottom: 16, color: "#666" }}>
          Escolha com qual caixa deseja continuar.
        </div>

        <Select
          style={{ width: "100%" }}
          placeholder="Selecione um caixa..."
          value={caixaSelecionado}
          onChange={setCaixaSelecionado}
          size="large"
        >
          {caixasDisponiveis.map((caixa) => (
            <Select.Option key={caixa.id} value={caixa.id}>
              {caixa.descricao || "Caixa sem descrição"}
            </Select.Option>
          ))}
        </Select>
      </Modal>

      <Modal
        visible={isModalVisible} // AntD v4. Se for v5: open={isModalVisible}
        onCancel={handleExitClick}
        footer={null}
        width="100%"
        style={{ top: 0 }}
        centered
        closeIcon={null}
        className="full-screen-modal"
      >
        <ModalHeader>
          <Button
            type="primary"
            onClick={handleExitClick}
            style={{ backgroundColor: "black", borderColor: "black" }}
          >
            <span style={styles.buttonText}>
              Abandonar <FontAwesomeIcon icon={faSignOutAlt} />
            </span>
          </Button>

          {/* ✅ só mostra quando não tem produtos E está em vendas/orçamentos */}
          {produtos.length === 0 &&
            (modalKey === "vendas" || modalKey === "orcamentos" || modalKey === "pedidos") && (
              <Button
                type="primary"
                onClick={recuperarVenda}
                style={{ backgroundColor: "black", borderColor: "black" }}
                loading={loading}
              >
                <span style={styles.buttonText}>
                  <FontAwesomeIcon icon={faClockRotateLeft} />
                  {' - Recuperar Última Abandonada'}
                </span>
              </Button>
            )}
        </ModalHeader>

        <ModalBody>
          {modalKey === "vendas" && (
            <TelaVendas
              sessaoCaixa={sessaoCaixa}
              produtos={produtos}
              setProdutos={setProdutos}
              trataProdutos={trataProdutos}
              pagamentoConcluido={pagamentoConcluido}
              setPagamentoConcluido={setPagamentoConcluido}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              consumidorIdentificado={consumidorIdentificado}
              setConsumidorIdentificado={setConsumidorIdentificado}
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              pagItem={pagItem}
              setPagItem={setPagItem}
              setSessaoCaixa={setSessaoCaixa}
              handleCloseModal={handleCloseModal}
              caixa={caixa}
            />
          )}

          {modalKey === "orcamentos" && <Orcamentos
            tipoTela={"Orçamentos"}
            produtos={produtos}
            setProdutos={setProdutos}
            trataProdutos={trataProdutos}
            pagamentoConcluido={pagamentoConcluido}
            setPagamentoConcluido={setPagamentoConcluido}
            pagamentos={pagamentos}
            setPagamentos={setPagamentos}
            consumidorIdentificado={consumidorIdentificado}
            setConsumidorIdentificado={setConsumidorIdentificado}
            consumidor={consumidor}
            setConsumidor={setConsumidor}
            pagItem={pagItem}
            setPagItem={setPagItem} />}
          {modalKey === "pedidos" && <Orcamentos
            tipoTela={"Pedidos"}
            sessaoCaixa={sessaoCaixa}
            produtos={produtos}
            setProdutos={setProdutos}
            trataProdutos={trataProdutos}
            pagamentoConcluido={pagamentoConcluido}
            setPagamentoConcluido={setPagamentoConcluido}
            pagamentos={pagamentos}
            setPagamentos={setPagamentos}
            consumidorIdentificado={consumidorIdentificado}
            setConsumidorIdentificado={setConsumidorIdentificado}
            consumidor={consumidor}
            setConsumidor={setConsumidor}
            pagItem={pagItem}
            setPagItem={setPagItem}
            setSessaoCaixa={setSessaoCaixa}
            handleCloseModal={handleCloseModal}
          />
          }
          {modalKey === "cancelamento" && <Cancelamento sessaoCaixa={sessaoCaixa} />}
          {modalKey === "devolucao" && <Devolucao />}
          {modalKey === "reimpressao" && <Reimpressao />}
          {modalKey === "log" && <Log />}
        </ModalBody>
      </Modal>
    </Container>
  );
};

const styles = {
  buttonStyled: {
    width: "150px",
    height: "150px",
    border: "none",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "16px",
    margin: "10px",
  },
  buttonText: {
    color: "#fff",
    fontWeight: "bold",
  },
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;
  position: relative;
  width: 100%;
`;

const ButtonText = styled.span`
  margin-top: 10px;
  font-weight: bold;
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between; /* cada um em uma ponta */
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  width: 100%;
`;

const ModalBody = styled.div`
  padding: 0;
  margin: 0;
  height: 92vh;
  width: 100%;
`;

export default Vendas;
